<div class="component-main-container">
  <app-page-header parentTitle="{{ 'report-charts.report-charts-label' | translate }}"
    pageTitle="{{ 'report-charts.generate-report-charts-label' | translate }}">
  </app-page-header>
  <div class="row">
    <!-- Caixa do formulário -->
    <div class="col-lg-12 col-xl-12 col-sm-12">
      <div class="component-forms-box">
        <div class="form-fields-box" [ngClass]="!createChartBox ? 'closed' : ''">
          <div class="gen-chart">
            <h3 (click)="createChartBoxOpen()">
              {{ "report-charts.create-form-title" | translate }}
            </h3>
            <hr [ngClass]="createChartBox ? 'hr-open' : ''" />
            <!-- Passo 1 - Buscar instalação -->
            <div class="installation-step">
              <div class="chart-creation-step">
                <div class="circle-number" [ngClass]="step1IsConcluded ? 'circle-number-ready' : ''">
                  1
                </div>
                <mat-form-field class="example-form-field" appearance="fill">
                  <mat-label>
                    {{ "report-charts.filter-label" | translate }}
                  </mat-label>
                  <input (keydown.enter)="searchInstallations()" [formControl]="installationReferenceForm" matInput
                    type="text" />
                  <button matSuffix mat-icon-button aria-label="Clear" class="search-icon-button"
                    (click)="searchInstallations()">
                    <mat-icon svgIcon="bx-search"></mat-icon>
                  </button>
                </mat-form-field>
              </div>
              @if (isLoadingInstallationSearch) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }

              <!-- Passo 2 - Escolher instalação -->
              @if (
              step1IsConcluded &&
              isThereInstallationListed &&
              !noInstallationWarning
              ) {
              <div class="chart-creation-step">
                <div class="circle-number" [ngClass]="step2IsConcluded ? 'circle-number-ready' : ''">
                  2
                </div>
                <mat-form-field class="example-form-field" appearance="fill">
                  <mat-label>
                    {{ "report-charts.select-installation" | translate }}
                  </mat-label>
                  <mat-select [formControl]="selectedInstallationForm" (selectionChange)="isStep2Concluded()">
                    <mat-option>
                      {{ "report-charts.select-installation" | translate }}</mat-option>
                    @for (installation of filteredInstallations; track installation) {
                    <mat-option [value]="installation">
                      {{ installation.reference }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }

              <!-- Passo 3 - Escolher o contador (somente equipamentos de pulso) -->
              @if (step2IsConcluded && isPulseInstallation) {
              <div class="chart-creation-step">
                <div class="circle-number circle-number-ready">
                  3
                </div>
                <mat-form-field class="example-form-field" appearance="fill">
                  <mat-label>
                    {{ "report-charts.select-counter" | translate }}
                  </mat-label>
                  <mat-select [formControl]="selectedCounterForm">
                    @for (counter of counterOptions; track counter) {
                    <mat-option [value]="counter">
                      {{ "report-charts.counter-meter" | translate }} {{ counter }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }

              <!-- Passo 4 (ou 3, sem contador) - Escolhe range de data -->
              @if (step2IsConcluded) {
              <div class="chart-creation-step">
                <div class="circle-number" [ngClass]="step3IsConcluded ? 'circle-number-ready' : ''">
                  {{ isPulseInstallation ? 4 : 3 }}
                </div>
                <div class="date-picker-input" [formGroup]="range">
                  <p-datepicker inputId="calendar-24h" selectionMode="range" appendTo="body" formControlName="rangeDate"
                    placeholder="Insira um intervalo de datas" showIcon iconDisplay="input" dateFormat="dd/mm/yy"
                    changeOnSelect (onSelect)="isStep3Concluded()">
                  </p-datepicker>
                </div>

                <!-- <mat-form-field appearance="outline">
                      <mat-label>Enter a date range</mat-label>
                      <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                        <input matStartDate formControlName="startDate" placeholder="Start date" />
                        <input (dateChange)="isStep3Concluded()" matEndDate formControlName="endDate"
                          placeholder="End date" />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field> -->
              </div>
              }

              @if (step1IsConcluded && selectedInstallations.length != 0) {
              <p class="font-weight-light hint-text">
                {{ "report-charts.all-installations-selected" | translate }}
              </p>
              }
              @if (noInstallationWarning) {
              <p class="font-weight-light hint-text">
                {{ "report-charts.installation-not-found" | translate }}
              </p>
              }

              @if (!isGeneratingChart) {
              <button [disabled]="!enableGenerationButton()" (click)="generateChart()"
                class="btn btn-success mb-2 w-10">
                {{ "report-charts.filter-button" | translate }}
              </button>
              }
              @if (isGeneratingChart) {
              <mat-spinner [diameter]="30"></mat-spinner>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Caixa do gráfico -->
    <div class="col-lg-12 col-xl-12 col-sm-12">
      <div class="chart-column table-div mt-2 mt-lg-3 mt-xl-3"
        [style.visibility]="!inInitialState ? 'visible' : 'hidden'">
        <canvas id="MyChart">{{ chartVariable }}</canvas>
        <div class="table">
          <div class="d-flex justify-content-between align-items-center ">
            <h1>{{ "report-charts.table-title" | translate }}</h1>
            <div class="downloads-icon">
              @if (chartData.length > 0) {
              <h3>
                Downloads:
                <strong (click)="downloadChartCsv()"> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                    fill="currentColor" class="bi bi-filetype-csv" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z" />
                  </svg></strong>
                <strong (click)="downloadChartPDF()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                    class="bi bi-filetype-pdf" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z" />
                  </svg>
                </strong>
              </h3>
              }
            </div>
          </div>

          <!-- Table box -->
          @if (!isPulseChart && !isReadChart) {
          <div class="table-box">
            <p-table [value]="chartData" [rows]="20" [totalRecords]="chartData.length" [paginator]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="dateTime">{{ "report-charts.date-time-table" | translate }}</th>
                  <th pSortableColumn="voltage">{{ "report-charts.voltage-table" | translate }}</th>
                  <th pSortableColumn="current">{{ "report-charts.current-table" | translate }}</th>
                  <!-- Será adicionada novamente após correções -->
                  <!-- <th pSortableColumn="power" >{{ "report-charts.time-table" | translate }}</th> -->
                  <th pSortableColumn="apparentPower">{{ "report-charts.apparent-power-table" | translate }}</th>
                  <th pSortableColumn="power"> {{ "report-charts.power-table" | translate }}</th>
                  <th pSortableColumn="consumption">{{ "report-charts.consumption-table" | translate }}</th>
                  <th pSortableColumn="powerFactor">{{ "report-charts.power-factor-table" | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
                <tr>
                  <td>{{row.dateTime}}</td>
                  <td>{{row.voltage}}</td>
                  <td>{{row.current}}</td>
                  <td>{{row.apparentPower}}</td>
                  <td>{{row.power}}</td>
                  <td>{{row.consumption}}</td>
                  <td>{{row.powerFactor}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          }

          @if (isPulseChart) {
          <div class="table-box">
            <p-table [value]="chartData" [rows]="20" [totalRecords]="chartData.length" [paginator]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="dateTime">{{ "report-charts.date-time-table" | translate }}</th>
                  <th pSortableColumn="consumption">{{ "report-charts.consumption-table-pulse" | translate }}</th>
                  <th pSortableColumn="time">{{ "report-charts.time-table" | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
                <tr>
                  <td>{{row.dateTime}}</td>
                  <td>{{row.consumption}}</td>
                  <td>{{row.time}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          }
          @if (isReadChart) {
          <div class="table-box">
            <p-table [value]="chartData" [rows]="20" [totalRecords]="chartData.length" [paginator]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="dateTime">{{ "report-charts.date-time-table" | translate }}</th>
                  <th pSortableColumn="consumption">{{ "report-charts.consumption-table" | translate }}</th>
                  <th pSortableColumn="time">{{ "report-charts.time-table" | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
                <tr>
                  <td>{{row.dateTime}}</td>
                  <td>{{row.consumption}}</td>
                  <td>{{row.time}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          }

          <!-- Tabela Pulso -->

          <!-- Tabela Read -->

          <!-- Tabela IPS -->
        </div>
      </div>
    </div>
  </div>
</div>